import { HttpParams } from '@angular/common/http';
import { QueryParam } from '../interfaces';

/**
 * Helper function to create Query Parameter String for a QueryParam object
 * It skips the keys, whose value is falsy
 * @param params QueryParam
 */
export function createQueryParamString(params: QueryParam): string {
  let httpParams = new HttpParams();
  Object.keys(params).forEach((key: string) => {
    const value: string = params[key] || '';
    if (value) {
      httpParams = httpParams.set(key, value);
    }
  });
  const queryString: string = httpParams.toString();
  return queryString ? '?' + queryString : '';
}
